export default __webpack_public_path__ + "static/media/trello_boards.995f906f.png";